import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading, selectReflections, selectTotal, selectPage, selectLimit } from '../selectors/reflections.selector';
import { reflectionsActions } from '../actions/reflections.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class ReflectionsFacade {
    private store = inject(Store);

    readonly reflections = this.store.selectSignal(selectReflections);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly page = this.store.selectSignal(selectPage);
    readonly limit = this.store.selectSignal(selectLimit);

    getReflections(value: PaginationParams): void {
        this.store.dispatch(reflectionsActions.getReflections({ value }));
    }

    clear(): void {
        this.store.dispatch(reflectionsActions.clear());
    }
}
